import React from 'react';

import {BoxScoresWidgetProps} from "../models/box-scores-widget.props";
import {PlayersList} from "../../../core/components/list/components/players-list/players-list";
import {LineupsMemberViewModel} from "../../../domain/yard/lineups/lineups-member/lineups-member-view-model";
import classNames from "classnames";
import styles from "../styles/box-scores-widget.module.scss";

export class BoxScoresWidgetPlayersListsProps extends BoxScoresWidgetProps {
  missingList: Array<LineupsMemberViewModel>;
  doubtfulList: Array<LineupsMemberViewModel>;
  willNotPlayList: Array<LineupsMemberViewModel>;
  missingTitle: String;
  doubtfulTitle: String;
  willNotPlayTitle: String;
  showMissingSection: Boolean;
  showDoubtfulSection: Boolean;
  showWillNotPlaySection: Boolean;
  isSmallView: Boolean;
}

export const BoxScoresWidgetPlayersLists = (props: BoxScoresWidgetPlayersListsProps) => {
  const shouldRenderPlayersList: Boolean = props.showMissingSection || props.showDoubtfulSection || props.showWillNotPlaySection;

  const missingPlayersListProps = {
    title: props.missingTitle,
    list: props.missingList,
    isSmallView: props.isSmallView,
    controller: props.controller,
    isMissingPlayersList: true
  }

  const doubtfulPlayersListProps = {
    title: props.doubtfulTitle,
    list: props.doubtfulList,
    isSmallView: props.isSmallView,
    controller: props.controller
  }

  const willNotPlayPlayersListProps = {
    title: props.willNotPlayTitle,
    list: props.willNotPlayList,
    isSmallView: props.isSmallView,
    controller: props.controller
  }

  return (
    shouldRenderPlayersList ? <div className={classNames(styles.players_list_container)}>
      {
        props.showMissingSection ? <PlayersList {...missingPlayersListProps}/> : null
      }
      {
        props.showDoubtfulSection ? <PlayersList {...doubtfulPlayersListProps}/> : null
      }
      {
        props.showWillNotPlaySection ? <PlayersList {...willNotPlayPlayersListProps}/> : null
      }
    </div> : null
  )
}
